import React from "react";
import styled from "styled-components";
import Header from "../components/Header";

const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;
const Section = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 100px;
  padding-top: 10px;
  font-family: Arial, sans-serif;
  color: #333;
  height: 100%;
`;
const PrivacyPolicy: React.FC = () => {
  return (
    <PageWrapper>
    <Header />
    <Section>
      <h1>개인정보처리방침</h1>
      <section>
        <h2>제1조(목적)</h2>
        <p>
          새록새록(이하 ‘회사’ 라고 함)은 회사가 제공하고자 하는 서비스(이하 ‘회사 서비스’)를 이용하는 개인(이하 ‘이용자’ 또는 ‘개인’)의 정보(이하 ‘개인정보’)를 보호하기 위해, 개인정보보호법, 정보통신망 이용촉진 및 정보보호 등에 관한 법률(이하 ‘정보통신망법’) 등 관련 법령을 준수하고, 서비스 이용자의 개인정보 보호 관련한 고충을 신속하고 원활하게 처리 할 수 있도록 하기 위하여 다음과 같이 개인정보처리방침(이하 ‘본 방침’)을 수립합니다.
        </p>
        
        <h2>제2조(개인정보 처리의 원칙)</h2>
        <p>
          개인정보 관련 법령 및 본 방침에 따라 회사는 이용자의 개인정보를 수집할 수 있으며 수집된 개인정보는 개인의 동의가 있는 경우에 한해 제3자에게 제공될 수 있습니다. 단, 법령의 규정 등에 의해 적법하게 강제되는 경우 회사는 수집한 이용자의 개인정보를 사전에 개인의 동의 없이 제3자에게 제공할 수도 있습니다.
        </p>

        <h2>제3조(본 방침의 공개)</h2>
        <p>
          1. 회사는 이용자가 언제든지 쉽게 본 방침을 확인할 수 있도록 회사 홈페이지 첫 화면 또는 서비스이용약관을 통해 본 방침을 공개하고 있습니다.  
          2. 회사는 제1항에 따라 본 방침을 공개하는 경우 글자 크기, 색상 등을 활용하여 이용자가 본 방침을 쉽게 확인할 수 있도록 합니다.
        </p>

        <h2>제4조(본 방침의 변경)</h2>
        <p>
          1. 본 방침은 개인정보 관련 법령, 지침, 고시 또는 정부나 회사 서비스의 정책이나 내용의 변경에 따라 개정될 수 있습니다.  
          2. 회사는 제1항에 따라 본 방침을 개정하는 경우 다음 각 호 하나 이상의 방법으로 공지합니다.
          <ul>
            <li>회사가 운영하는 인터넷 홈페이지의 첫 화면의 공지사항란 또는 별도의 창을 통하여 공지하는 방법</li>
            <li>서면·모사전송·전자우편 또는 이와 비슷한 방법으로 이용자에게 공지하는 방법</li>
          </ul>
          3. 회사는 제2항의 공지는 본 방침 개정의 시행일로부터 최소 7일 이전에 공지합니다. 다만, 이용자 권리의 중요한 변경이 있을 경우에는 최소 30일 전에 공지합니다.
        </p>

        <h2>제5조(회원 가입을 위한 정보)</h2>
        <p>
          회사는 이용자의 회사 서비스에 대한 회원가입을 위하여 다음과 같은 정보를 수집합니다.  
          1. 필수 수집 정보: 이메일 주소 및 닉네임, 아이디  
          2. 선택 수집 정보: 프로필 사진
        </p>

        <h2>제6조(본인 인증을 위한 정보)</h2>
        <p>
          회사는 이용자의 본인인증을 위하여 다음과 같은 정보를 수집합니다.  
          1. 필수수집 정보: 휴대폰 번호 및 이메일 주소
        </p>

        <h2>제7조(회사 서비스 제공을 위한 정보)</h2>
        <p>
          회사는 이용자에게 회사의 서비스를 제공하기 위하여 다음과 같은 정보를 수집합니다.  
          1. 필수 수집 정보: 아이디 및 이메일 주소
        </p>

        <h2>제8조(서비스 이용 및 부정 이용 확인을 위한 정보)</h2>
        <p>
          회사는 이용자의 서비스 이용에 따른 통계•분석 및 부정이용의 확인•분석을 위하여 다음과 같은 정보를 수집합니다.  
          1. 필수 수집 정보: 서비스 이용기록, 접속지 정보 및 기기정보
        </p>

        <h2>제9조(개인정보 수집 방법)</h2>
        <p>
          회사는 다음과 같은 방법으로 이용자의 개인정보를 수집합니다.  
          1. 이용자가 회사의 모바일 앱에 자신의 개인정보를 입력하는 방식  
          2. 어플리케이션 등 회사가 제공하는 홈페이지 외의 서비스를 통해 이용자가 자신의 개인정보를 입력하는 방식  
          3. 이용자가 고객센터의 상담, 게시판에서의 활동 등 회사의 서비스를 이용하는 과정에서 이용자가 입력하는 방식  
          4. 이용자가 서비스 이용을 위해 카카오톡 및 애플 로그인을 진행하는 과정에서 입력되는 방식
        </p>

        <h2>제10조(개인정보의 이용)</h2>
        <p>
          회사는 개인정보를 다음 각 호의 경우에 이용합니다.  
          1. 공지사항의 전달 등 회사운영에 필요한 경우  
          2. 이용문의에 대한 회신, 불만의 처리 등 이용자에 대한 서비스 개선을 위한 경우  
          3. 회사의 서비스를 제공하기 위한 경우  
          4. 법령 및 회사 약관을 위반하는 회원에 대한 이용 제한 조치, 부정 이용 행위를 포함하여 서비스의 원활한 운영에 지장을 주는 행위에 대한 방지 및 제재를 위한 경우  
          5. 인구통계학적 분석, 서비스 방문 및 이용기록의 분석을 위한 경우  
          6. 개인정보 및 관심에 기반한 이용자간 관계의 형성을 위한 경우
        </p>

        <h2>제11조(개인정보의 보유 및 이용기간)</h2>
        <p>
          1. 회사는 이용자의 개인정보에 대해 개인정보의 수집·이용 목적 달성을 위한 기간 동안 개인정보를 보유 및 이용합니다.  
          2. 전항에도 불구하고 회사는 내부 방침에 의해 서비스 부정이용기록은 부정 가입 및 이용 방지를 위하여 회원 탈퇴 시점으로부터 최대 1년간 보관합니다.
        </p>

        <h2>제12조(개인정보의 파기 원칙)</h2>
        <p>회사는 원칙적으로 이용자의 개인정보 처리 목적의 달성, 보유·이용기간의 경과 등 개인정보가 필요하지 않을 경우에는 해당 정보를 지체 없이 파기합니다.</p>

        <h2>제13조(개인정보파기절차)</h2>
        <p>
          1. 이용자가 회원가입 등을 위해 입력한 정보는 개인정보 처리 목적이 달성된 후 별도의 DB로 옮겨져(종이의 경우 별도의 서류함) 내부 방침 및 기타 관련 법령에 의한 정보보호 사유에 따라(보유 및 이용기간 참조) 일정 기간 저장된 후 파기 되어집니다.  
          2. 회사는 파기 사유가 발생한 개인정보를 개인정보보호 책임자의 승인절차를 거쳐 파기합니다.
        </p>

        <h2>제14조(개인정보파기방법)</h2>
        <p>
          회사는 전자적 파일형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제하며, 종이로 출력된 개인정보는 분쇄기로 분쇄하거나 소각 등을 통하여 파기합니다.
        </p>

        <h2>제15조(이용자의 의무)</h2>
        <p>
          1. 이용자는 자신의 개인정보를 최신의 상태로 유지해야 하며, 이용자의 부정확한 정보 입력으로 발생하는 문제의 책임은 이용자 자신에게 있습니다.  
          2. 타인의 개인정보를 도용한 회원가입의 경우 이용자 자격을 상실하거나 관련 개인정보보호 법령에 의해 처벌받을 수 있습니다.  
          3. 이용자는 전자우편주소, 비밀번호 등에 대한 보안을 유지할 책임이 있으며 제3자에게 이를 양도하거나 대여할 수 없습니다.
        </p>

        <h2>제16조(개인정보 유출 등에 대한 조치)</h2>
        <p>
          회사는 개인정보의 분실·도난·유출(이하 “유출 등”이라 한다) 사실을 안 때에는 지체 없이 다음 각 호의 모든 사항을 해당 이용자에게 알리고 방송통신위원회 또는 한국인터넷진흥원에 신고합니다.  
          1. 유출 등이 된 개인정보 항목  
          2. 유출 등이 발생한 시점  
          3. 이용자가 취할 수 있는 조치  
          4. 정보통신서비스 제공자 등의 대응 조치  
          5. 이용자가 상담 등을 접수할 수 있는 부서 및 연락처
        </p>

        <h2>제17조(개인정보 유출 등에 대한 조치의 예외)</h2>
        <p>
          회사는 전조에도 불구하고 이용자의 연락처를 알 수 없는 등 정당한 사유가 있는 경우에는 회사의 모바일 앱에 30일 이상 게시하는 방법으로 전조의 통지를 갈음하는 조치를 취할 수 있습니다.
        </p>

        <h2>제18조(개인정보 자동 수집 장치의 설치·운영 및 거부에 관한 사항)</h2>
        <p>
          1. 회사는 이용자에게 보다 원활하고 개인화된 서비스를 제공하기 위하여, 토큰 기반 인증 방식을 통해 이용자의 접속 정보, 서비스 이용기록 등을 자동으로 수집·저장할 수 있습니다.  
          2. 자동 수집되는 정보는 로그인 상태 유지, 맞춤형 서비스 제공, 서비스 품질 향상 및 보안 강화를 위한 목적으로만 사용되며, 해당 정보만으로는 개인을 식별하기 어렵습니다.  
          3. 이용자는 모바일 기기 또는 앱 설정을 통해 일부 정부 수집을 제한할 수 있으나, 이 경우에는 로그인이 필요한 회사의 일부 서비스는 이용에 어려움이 있을 수 있습니다.
        </p>

        <h2>제19조(회사의 개인정보 보호 책임자 지정)</h2>
        <p>
          1. 회사는 이용자의 개인정보를 보호하고 개인정보와 관련한 불만을 처리하기 위하여 아래와 같이 관련 부서 및 개인정보 보호 책임자를 지정하고 있습니다.  
          가. 개인정보 보호 책임자  
          1) 성명: 박채현  
          2) 직책: 개인정보 보호 책임자  
          3) 이메일: saerocksaelog@gmail.com
        </p>

        <h2>제20조(권익침해에 대한 구제방법)</h2>
        <p>
          1. 정보주체는 개인정보침해로 인한 구제를 받기 위하여 개인정보분쟁조정위원회, 한국인터넷진흥원 개인정보침해신고센터 등에 분쟁해결이나 상담 등을 신청할 수 있습니다. 이 밖에 기타 개인정보침해의 신고, 상담에 대하여는 아래의 기관에 문의하시기 바랍니다.  
          가. 개인정보분쟁조정위원회: (국번없이) 1833-6972 (www.kopico.go.kr)  
          나. 개인정보침해신고센터: (국번없이) 118 (privacy.kisa.or.kr)  
          다. 대검찰청: (국번없이) 1301 (www.spo.go.kr)  
          라. 경찰청: (국번없이) 182 (ecrm.cyber.go.kr)
        </p>

        <h2>부칙</h2>
        <p>제1조 본 방침은 2025.04.28부터 시행됩니다.</p>

      </section>
    </Section>
    </PageWrapper>

  );
};

export default PrivacyPolicy;
